import React from "react";
import { Box, Link, Typography } from "@material-ui/core";
import Pci from "../../../assets/logos/Pci";
import PowerKushki from "../../../assets/logos/PowerKushki";
import { Translate as T } from "react-localize-redux";
import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (theme) { return ({
    link: {
        color: "#6D7781",
        paddingLeft: theme.spacing(0.5),
        textDecoration: "underline",
    },
    text: {
        color: "#6D7781",
        fontSize: "12px",
    },
    pci: {
        height: theme.spacing(6),
        width: theme.spacing(15),
    },
    power: {
        height: theme.spacing(2.5),
        width: theme.spacing(15),
    },
}); });
export var CheckoutFooter = function () {
    var classes = useStyles();
    return (React.createElement(Box, { px: 3, pb: 2, mt: 2 },
        React.createElement(Box, { display: "flex", justifyContent: "center", p: 2 },
            React.createElement(PowerKushki, { className: classes.power })),
        React.createElement(Box, { display: "flex", justifyContent: "center", alignItems: "center", m: "auto", minWidth: "200px", maxWidth: "400px" },
            React.createElement(Pci, { className: classes.pci }),
            React.createElement(Box, { display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", px: 2 },
                React.createElement(Typography, { className: classes.text },
                    React.createElement(T, { id: "pci" }),
                    React.createElement(Link, { className: classes.link, href: "https://kushkipagos.com/en/blog/certificacion-pci-pagos-mas-seguros-para-tus-clientes-y-tu-negocio", target: "_blank" },
                        React.createElement(T, { id: "readMore" })))))));
};
